import React from 'react';
export function PainSection() {
  return <section className="border-b border-line bg-panel py-8 sm:py-10" data-id="element-150" data-mp="1rs46ptzpuxd9">
      <div className="mx-auto max-w-[1080px] px-4 sm:px-6" data-id="element-151" data-mp="38wvlkl3e57pj">
        <h2 className="max-w-[820px] text-[24px] font-bold leading-[1.02] text-white sm:text-[36px]" data-id="element-152" data-mp="2uy5kkudganvw">
          Stop guessing where the{' '}
          <span className="text-brandorange" data-id="element-153" data-mp="2yyfswdoptqdx">motorcycle fault starts</span>
        </h2>
        <div className="mt-3 h-1 w-16 bg-brandorange" aria-hidden="true" data-id="element-154" data-mp="2l82noj37kpsa" />
        <p className="mt-4 max-w-[820px] text-[14px] font-medium leading-snug text-metal sm:text-[17px]" data-id="element-155" data-mp="2pysrhrvzkkkv">
          Bike won't start? Battery keeps dying, engine misfires or power suddenly
          drops? Fuel, ignition, charging, ECU, sensors, mechanical systems... where
          does the fault actually start? MOTORCYCLE DIAGNOSTIC PRO™ gives you an
          organized visual troubleshooting system to help you identify motorcycle
          faults and follow a clearer diagnostic path.{' '}
          <strong className="font-bold text-white" data-id="element-156" data-mp="3rmr3nw73il0y">
            Identify. Test. Diagnose.
          </strong>
        </p>
      </div>
    </section>;
}